import {
  Component,
  OnInit,
  forwardRef,
  Input,
  ViewChild,
  ElementRef,
  AfterViewInit,
  Directive,
  HostListener,
} from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { FormBaseElement } from "../form-base-element";

@Component({
  selector: "app-text-input",
  templateUrl: "./text-input.component.html",
  styleUrls: ["./text-input.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextInputComponent),
      multi: true,
    },
  ],
})
export class TextInputComponent extends FormBaseElement {
  @Input("placeholder") placeholder: string;

  @Input("floatingPlaceholder") floatingPlaceholder: boolean = false;

  @Input("readonly") readonly: boolean = false;

  @Input("displayErrors") displayErrors: boolean = true;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}
